import React from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import MarqueeBand from "@/components/landing/Marquee";
import Solutions from "@/components/landing/Solutions";
import Configurator from "@/components/landing/Configurator";
import AutotunerFlex from "@/components/landing/AutotunerFlex";
import Manifesto from "@/components/landing/Manifesto";
import FAQ from "@/components/landing/FAQ";
import ContactFooter from "@/components/landing/ContactFooter";
import Seo from "@/components/Seo";
import { useLang } from "@/context/LanguageContext";

const Landing = () => {
  const { t } = useLang();
  return (
    <div className="relative min-h-screen bg-[#0A0A0A]" data-testid="landing-page">
      <Seo
        title={t.meta.title}
        description={t.meta.description}
        keywords={t.meta.keywords}
        path="/"
      />
      <Header />
      <main>
        <Hero />
        <MarqueeBand />
        <Solutions />
        <Configurator />
        <AutotunerFlex />
        <Manifesto />
        <FAQ />
      </main>
      <ContactFooter />
    </div>
  );
};

export default Landing;
